import { render, staticRenderFns } from "./AccessoriesCom.vue?vue&type=template&id=39ec8e57&scoped=true&"
import script from "./AccessoriesCom.vue?vue&type=script&lang=js&"
export * from "./AccessoriesCom.vue?vue&type=script&lang=js&"
import style0 from "./AccessoriesCom.vue?vue&type=style&index=0&id=39ec8e57&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ec8e57",
  null
  
)

export default component.exports